var React = require('react');

function PhoneIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(0.641 0.731)"},React.createElement("path",{"d":"M2.633,64.527l-.486.486c-1.995,1.995-6.4,1.63-10.954-2.926s-4.92-8.963-2.926-10.957l.483-.486a1.16,1.16,0,0,1,1.637,0l1.688,1.688a1.159,1.159,0,0,1,.016,1.619,3.209,3.209,0,0,0-.407,4.02A13.044,13.044,0,0,0-4.7,61.582a3.205,3.205,0,0,0,4.014-.4,1.161,1.161,0,0,1,1.625.01l1.688,1.688a1.159,1.159,0,0,1,.012,1.639Z","transform":"translate(12.885 -50.307)","fill":"none","stroke":"#c7a374","strokeMiterlimit":"10","strokeWidth":"1.25"})));
}

PhoneIcon.defaultProps = {"width":"17.231","height":"17.231","viewBox":"0 0 17.231 17.231"};

module.exports = PhoneIcon;

PhoneIcon.default = PhoneIcon;
